import style from "./tableRowColumns.module.css";
import sun from "../../assets/images/table/sun.svg";
import moon from "../../assets/images/table/moon.svg";
import wind from "../../assets/images/wind.svg";
import rain from "../../assets/images/rain.svg";
import humidity from "../../assets/images/humidity.svg";
import { SimpleWeatherIcon } from "../commons/getSimpleWeatherIcon";

export function showValueBasedOnColumn({ column, row }: any): any {
    switch (column?.id) {
        case "weather":
            return (
                <div className={style.weatherColumn}>
                    <SimpleWeatherIcon weather={row?.icon ? row.icon : ""} />
                    <div>
                        <strong>{row?.maxAirTemperature ? `${row.maxAirTemperature}°` : "--"}</strong>
                        <small>{row?.minAirTemperature ? `${row.minAirTemperature}°` : "--"}</small>
                    </div>
                </div>
            );

        case "sun":
            return (
                <div className={style.weatherColumn}>
                    <img src={sun} alt="Sun" />
                    <div className={style.sunColumn}>
                        <span>{row?.sunrise ? `${row.sunrise} AM` : "--"}</span>
                        <span>{row?.sunset ? `${row.sunset} PM` : "--"}</span>
                    </div>
                </div>
            );

        case "moon":
            return (
                <div className={style.weatherColumn}>
                    <img src={moon} alt="Moon" />
                    <div className={style.moonColumn}>
                        <span>{row?.moonrise ? `${row.moonrise} AM` : "--"}</span>
                        <span>{row?.moonset ? `${row.moonset} PM` : "--"}</span>
                    </div>
                </div>
            );

        case "precipitation":
            return (
                <div className={style.weatherColumn}>
                    <img src={rain} alt="Rain" />
                    <div className={style.moonColumn}>
                        <span className={style.others}>{row?.precipitation ? `${row.precipitation}mm` : "--"}</span>
                    </div>
                </div>
            );

        case "relHumidity":
            return (
                <div className={style.weatherColumn}>
                    <img src={humidity} alt="Humidity" />
                    <div className={style.moonColumn}>
                        <span className={style.others}>{row?.relHumidity ? `${row.relHumidity}%` : "--"}</span>
                    </div>
                </div>
            );

        case "wind":
            return (
                <div className={style.weatherColumn}>
                    <img src={wind} alt="Wind" />
                    <div className={style.moonColumn}>
                        <span className={style.others}>{row?.wind ? `${row.wind}Km/h` : "--"}</span>
                    </div>
                </div>
            );

        default:
            return <span className={style.textColumn}>{row?.[column?.id] ? row[column.id] : "--"}</span>;
    }
}